import React ,{useEffect} from 'react';
import { Trans, useTranslation } from "react-i18next";
import { usePay360Account } from '../../../../hooks/usePay360Account';
import { usePaymentState } from '../../../../hooks/usePaymentState';
import Loading from '../../../util/Loading';
import { PaymentsStatus } from '../types.d';
import PaymentStatus from '../Ui/PaymentStatus';

interface IPayWizardProps {
    inprogressHelperText:string[];
}

function Wizard({
    inprogressHelperText
}: IPayWizardProps) {
    const { requestPaymentStage } = usePay360Account();
    const { paymentStage, isError, paymentDetails } = usePaymentState();
    const { t } = useTranslation();
    useEffect(() => {
        requestPaymentStage();
    // eslint-disable-next-line    
    }, [])
    function renderInprogressHelperTexts(){
        if(inprogressHelperText.length>0){
            return inprogressHelperText.map((text:string,index:number)=><p key={index}>
                {t(text)}
            </p>)   
        }
    }
    function steps() {
        switch (paymentStage) {
            case 1:
                return (
                    <>
                        <PaymentStatus status={PaymentsStatus.Inprogress} message={t('payments.status.inprogress')} />
                        <section>
                            <p><Trans i18nKey="payments.barclaycard.content3"
                                components={{ bold: <strong /> }}
                            /></p>
                            <p>{t("payments.barclaycard.content4")}</p>
                            {renderInprogressHelperTexts()}
                        </section>
                    </>
                )
            case 2:
                return (
                    <>
                        <PaymentStatus status={PaymentsStatus.Active} message={t('payments.status.active')} />
                        <section>
                            <p>
                                <Trans i18nKey="payments.barclaycard.content6"
                                    components={{ bold: <strong /> }}
                                />
                            </p>
                        </section>
                    </>
                )
            default:
                return (
                    <Loading />
                )
        }
    }

    if (isError) {
        return <div>{t("payments.texts.error", { paymentProcessor: paymentDetails.paymentProcessor })}</div>;
    }
    return (
        <>
            {steps()}
        </>
    )
}

export default React.memo(Wizard);
